module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [(_vm.loading) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.package.addProductToPackageTitle')) + " "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('h3', {
    staticClass: "wizardTitle"
  }, [_vm._v(_vm._s(_vm.$t('static.orders.package.addProductToPackageTitle')))]), _vm._v(" "), _c('div', [(!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.addEditProductToPackage",
      "hasLabel": true
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.store
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b752cbea","hasScoped":false}!./src/app/components/addPackageOrderProduct/addPackageOrderProduct.html
// module id = 3109
// module chunks = 1